import React from 'react';
import { Button, Col, Form, Modal, Row, Upload, Table } from 'antd';
import { toast } from 'react-toastify';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import { UploadOutlined } from '@ant-design/icons';
import { ResponseDataType, postRequest } from 'api';
import styles from 'Pages/Class/ImportStudentList/import.module.css';

interface InputFileStudent {
  file: any;
}

interface FormValueType {
  file: any;
}

interface StudentImportModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSuccess: () => void;
}

export const StudentImportModal: React.FC<StudentImportModalProps> = ({ isOpen, onClose, onSuccess }) => {
  const [form] = Form.useForm();
  const schoolId = localStorage.getItem('schoolId');

  const HandleInputFile = (value: FormValueType) => {
    Modal.confirm({
      style: { fontFamily: 'Quicksand' },
      title: 'Xác nhận thêm tệp.',
      async onOk() {
        try {
          const formData = new FormData();
          formData.append('file', value.file[0].originFileObj);
          formData.append('schoolId', schoolId!.toString());
          const response: ResponseDataType<InputFileStudent> = await postRequest(
            '/cms/class/import-students',
            formData,
            'form-data'
          );
          if (response?.code === 200) {
            toast.success('Thêm tệp thành công!');
            onSuccess();
            onClose();
            form.resetFields();
          } else if (response?.code === -1020) {
            toast.error(response?.msg || 'File c� l?i');
            onClose();
            form.resetFields();
            window.location.href = '/student-list?tab=2';
          } else {
            if (response?.info && Array.isArray(response.info) && response.info.length > 0) {
              Modal.error({
                title: 'Dữ liệu file Excel không hợp lệ',
                width: 800,
                content: (
                  <div style={{ marginTop: '16px' }}>
                    <p style={{ marginBottom: '16px' }}>{response.msg || 'Vui lòng kiểm tra lại lỗi ở các dòng sau:'}</p>
                    <Table
                      dataSource={response.info}
                      pagination={false}
                      rowKey="rowIndex"
                      size="small"
                      scroll={{ y: 300 }}
                      columns={[
                        { title: 'STT', dataIndex: 'stt', key: 'stt', width: 60 },
                        { title: 'Tên học sinh', dataIndex: 'studentName', key: 'studentName', width: 180 },
                        { title: 'Mã định danh', dataIndex: 'studentCode', key: 'studentCode', width: 140 },
                        { title: 'Lỗi', dataIndex: 'reason', key: 'reason' },
                      ]}
                    />
                  </div>
                ),
              });
            } else {
              toast.error(response?.msg || 'Thêm tệp thất bại!');
            }
          }
        } catch (error) {
          toast.error('Lỗi khi import tệp!');
        }
      },
    });
  };

  const handleCancel = () => {
    form.resetFields();
    onClose();
  };

  return (
    <Modal
      title="Nhập danh sách học sinh"
      open={isOpen}
      onCancel={handleCancel}
      footer={null}
      destroyOnClose
    >
      <div style={{ marginBottom: '16px' }}>
        <a href="/import/import_students_template.xlsx" download>
          Tải file mẫu tại đây
        </a>
      </div>
      <Form form={form} onFinish={HandleInputFile} layout="vertical">
        <Row>
          <Col span={8}>
            <div className={styles.card_content_label}>
              <InsertDriveFileIcon />
              &nbsp;&nbsp;File:
            </div>
          </Col>
          <Col span={16}>
            <Form.Item
              name="file"
              valuePropName="fileList"
              getValueFromEvent={(e) => (Array.isArray(e) ? e : e && e.fileList)}
              rules={[
                { required: true, message: 'Cần nhập file!' },
                {
                  validator: (_, value) =>
                    value && value.length > 0 && /\.(xlsx|xls)$/i.test(value[0].name)
                      ? Promise.resolve()
                      : Promise.reject(new Error('Chỉ chấp nhận file Excel!')),
                },
              ]}
            >
              <Upload beforeUpload={() => false}>
                <Button icon={<UploadOutlined />}>Chọn file</Button>
              </Upload>
            </Form.Item>
          </Col>
        </Row>

        <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 16 }}>
          <Button onClick={handleCancel} style={{ marginRight: 8 }}>
            Hủy
          </Button>
          <Button type="primary" htmlType="submit">
            IMPORT FILE
          </Button>
        </div>
      </Form>
    </Modal>
  );
};
